import script from "./CachePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CachePage.vue?vue&type=script&setup=true&lang=ts"

import "./CachePage.vue?vue&type=style&index=0&id=e9ec5440&scoped=true&lang=css"
import "./CachePage.vue?vue&type=style&index=1&id=e9ec5440&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9ec5440"]])

export default __exports__